export default __webpack_public_path__ + "static/media/trackYourReadingDark@2x.7a7d4b36.png";